/*
 * @Author: cc
 * @Date: 2019-12-26 11:46:35
 * @LastEditTime: 2021-06-10 13:08:40
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\app\toBeCompiled\audio\app_audio.js
 * @Description: app 音频稿
 */

angular.module('editingCenterAppAudioModule', []).controller('editingCenterAppAudioController', [
    '$scope',
    'beforeonload',
    '$element',
    '$state',
    '$window',
    '$compile',
    '$validation',
    '$q',
    '$filter',
    '$timeout',
    'trsHttpService',
    'editingCenterAppService',
    'editcenterRightsService',
    'initAddMetaDataService',
    'initAppRequiredBtnService',
    'appDictionaryBtnService',
    'filterEditctrBtnsService',
    'initeditctrBtnsService',
    'localStorageService',
    'editIsLock',
    'editingCenterService',
    'ueditorService',
    'trsSelectDocumentService',
    'trsspliceString',
    'sensitiveWordCheckService',
    'modalDialog',
    'jsonArrayToStringService',
    'storageListenerService',
    'editCenUploadVideoForXjService',
    'loginService',
    'globleParamsSet',
    '$sessionStorage',
    'newMediaService',
    'appConst',
    'messagePublishService',
    'publicToolService',
    function (
        $scope,
        beforeonload,
        $element,
        $state,
        $window,
        $compile,
        $validation,
        $q,
        $filter,
        $timeout,
        trsHttpService,
        editingCenterAppService,
        editcenterRightsService,
        initAddMetaDataService,
        initAppRequiredBtnService,
        appDictionaryBtnService,
        filterEditctrBtnsService,
        initeditctrBtnsService,
        localStorageService,
        editIsLock,
        editingCenterService,
        ueditorService,
        trsSelectDocumentService,
        trsspliceString,
        sensitiveWordCheckService,
        modalDialog,
        jsonArrayToStringService,
        storageListenerService,
        editCenUploadVideoForXjService,
        loginService,
        globleParamsSet,
        $sessionStorage,
        newMediaService,
        appConst,
        messagePublishService,
        publicToolService
    ) {
        initStatus();
        initData();
        editingCenterAppService.addFuture($scope, ['sendmessage']);

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };

            $scope.status = {
                wordToAudioShield: false, // 是否屏蔽文字转语音功能
                pictureSize: {},
                type: 'audio',
                newsFormError: [],
                switch: 'manuscriptInfo', // 默认选中稿件信息
                support: {
                    content: '', // 提交给辅助写作的纯文本
                },
                isCheckSensitiveWords: false,
                zhengwen: false,
                openBtn: true,
                bigFaceSwitch: { status: false },
                sensitiveWordTit: '敏感词校验',
                isSecondReview: false,
                isSignedOrRevoked: false,
                audioVideoidsArray: [],
                isEditDraft: !!$state.params.appmetadataid,
                position: $state.params.appplatform,
                heimaCheckTit: '错别字校对',
                isawaitrevise: $state.params.isawaitrevise,
                uploadOrChage: 'upload', // 音频稿这里氛围两种模式：文字转语音和本地上传，默认是上传模式
                hasTitleSynced: false, // 标题是否已经同步给列表标题
            };

            $scope.data = {
                specialDoc: 0,
                userName: '',
                label: '',
                trench: appConst.params.listenStroageKey,
                relNewsSelectedItems: [],
                relSubjectSelectedItems: [],
                relSubjectGroup: [], // 相关专题分组
                relSubjectSelectedGroup: [], // 相关专题所选分组
                selectNewArray: [], // 相关新闻选中数据
                selectSubjectArray: [], // 相关专题选中数据
                commentSet: editingCenterAppService.initCommentSet(), // 初始化评论设置
                docGenre: editingCenterAppService.initDocGenre(), // 初始化稿件题材
                copyVersion: [],
                version: [],
                KEYWORDS: [],
                path: {
                    '-1': 'editingCenterIwoPersonalVersionTime',
                    '1': 'editingCenterAppPersonalVersionTime',
                    '2': 'editingCenterWebsitePersonalVersionTime',
                    '3': 'editingCenterPaperPersonalVersionTime',
                    '4': 'editingCenterWeixinPersonalVersionTime',
                },
                selectedVideoArray: [], // 选择的视频
                comment: {
                    comment: [],
                    voiceObj: {},
                    hasMore: false,
                    currPage: 1,
                },
                audioUrl: '',
                fileName: '',
                listPicRatio: {
                    set: {
                        0: '',
                    },
                    practical: {
                        0: '1',
                    },
                },
                focusRatio: {
                    set: '',
                    practical: '1',
                },
                bigPicRtion: {
                    set: '', // 大图只需要设置的值不需要单独实际值，因为大图使用的是列表图的第一张
                },
                specZtPicRtion: {
                    set: '', // 窄图
                },
                listStyle: [
                    {
                        desc: '图文',
                        value: '0',
                    },
                    {
                        desc: '大图',
                        value: '3',
                    },
                    {
                        desc: '窄图',
                        value: '4',
                    },
                ], // 列表样式
            };
            $scope.uploader = {
                // 本地上传需要的
                example: '',
                progress: 0,
                fastVideoTimer: '',
                fastVideoInfo: {}, // 视频快编信息
                uploaderOptions: angular.extend({}, editCenUploadVideoForXjService.singleAudioOption), // 上传配置项
            };
            $scope.audio = {
                // 文字转语音需要的
                lastWords: 50, // 最小需要字数
                rotation: false, // 语音转文字轮训
                audieoTimer: {}, // 音频定时器
                interval: 5 * 1000, // 查询间隔
            };
            $scope.params = {
                serviceid: 'mlf_appmetadata',
                methodname: 'getAudioDoc',
                ChnlDocId: $state.params.appchnldocid,
            };
            $scope.status.hasVersionTime = !!angular.isDefined($state.params.appchnldocid);
            emitCloseWindow();
            $scope.editFlag = {
                media: 'app',
                docType: 'audio',
            };
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            getCutPictureWidthHeight();
            // 初始化标签
            editingCenterAppService.initTag($state.params.appsiteid).then(function (list) {
                $scope.data.label = angular.copy(list);
            });
            ($state.params.appchnldocid ? initEditData() : initNewData()).then(function () {
                if (!$scope.data.imgSize && $scope.list) {
                    changeMode($scope.list.LISTSTYLE || '0');
                }
                getZrbj();
                beforeonload.beforeonloadAlert($scope);
            });
            initBtnArray();
            publicToolService.getModeconfiguration('wordToAudio').then((config) => {
                $scope.status.wordToAudioShield = config.shield;
            });
        }

        /**
         * [getZrbj description] 获取责任编辑
         * @return  {[type]}  [return description]
         */
        function getZrbj() {
            let trueName = $sessionStorage.get('curUserInfo').TRUENAME;
            $scope.list.RESPONSIBLEEDITOR = $scope.list.RESPONSIBLEEDITOR ? $scope.list.RESPONSIBLEEDITOR : trueName;
        }

        /**
         * [initEditData description] 初始化编辑页
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]1
         */
        function initEditData() {
            var defer = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function (data) {
                $scope.list = data;
                document.title = data.TITLE;
                $scope.list.LISTSTYLE = $scope.list.LISTSTYLE ? $scope.list.LISTSTYLE : 0; // 解决取稿后列表样式没有的问题
                $scope.data.relNewsSelectedItems = angular.isDefined(data.RELATEDNEWS) ? data.RELATEDNEWS : [];
                $scope.status.isSecondReview = !!(angular.isDefined(data.ISSECONDREVIEW) && data.ISSECONDREVIEW == '1');
                initKeyWords();
                initRelavantSpecialDoc();
                syncTitleToListTitle();
                reWriteImg();
                // 获取流程版本与操作日志
                getVersion()
                    .then(function (data) {
                        return loadDirective();
                    })
                    .then(function () {
                        defer.resolve();
                    });
                getPropagandaReview();
                examineAudio();
                $scope.$on('$destroy', function () {
                    $timeout.cancel($scope.uploader.fastVideoTimer);
                    $timeout.cancel($scope.audio.audieoTimer);
                });
            });
            // 稿件加锁
            editIsLock.lockDraft($state.params.appmetadataid);
            return defer.promise;
        }

        /**
         * [examineVideo description] 音频检查
         * @return {[type]} [description]
         */
        function examineAudio() {
            if ($scope.list.VIDEOREL[0].PLATFORMFLAG === 'BDAudioObject') {
                // 表示为文字转音频
                $scope.status.uploadOrChage = 'change';
            } else {
                // 表示为上传的音频
                var videoInfo = localStorageService.get('videoUploadAppInfo');
                editCenUploadVideoForXjService.exampleVideo(videoInfo, $scope.list, $state.params.appmetadataid).then(
                    function (data) {
                        $scope.list.VIDEOREL[0].AUDIOVIDEOID = data[0]; // 再次回写ID
                        getVideoInfo();
                    },
                    function () {
                        getVideoInfo();
                    }
                );
            }
        }
    
    
        /**
         * [initRelavantSpecialDoc description] 初始化相关专题
         * @return {[type]} [description]1
         */
        function initRelavantSpecialDoc() {
            if (angular.isDefined($scope.list.RELEVANTSPECIALDOC) && $scope.list.RELEVANTSPECIALDOC.length != 0) {
                angular.forEach($scope.list.RELEVANTSPECIALDOC, function (data, index) {
                    $scope.data.relSubjectSelectedItems.push({
                        METADATAID: data.METADATAID,
                        LISTTITLE: data.LISTTITLE,
                        SPECIALGROUPID: data.SPECIALGROUPID,
                    });
                    $scope.data.relSubjectSelectedGroup.push({
                        name: data.SPECIALGROUPNAME,
                        value: data.SPECIALGROUPID,
                    });
                });
                var i = 0;
                initRelSubjectGroup($scope.list.RELEVANTSPECIALDOC[i]);
            }

            /**
             * [initRelSubjectGroup description] 初始化相关专题稿件的分组
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            function initRelSubjectGroup(item) {
                var params = {
                    methodname: 'querySpecialGroupsFromData',
                    serviceid: 'mlf_specialgroup',
                    MetaDataId: item.METADATAID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.data.relSubjectGroup[i] = data.DATA;
                    angular.forEach($scope.data.relSubjectGroup[i], function (value, key) {
                        value.name = value.SPECIALGROUPNAME;
                        value.value = value.SPECIALGROUPID;
                    });
                    i++;
                    if (i < $scope.list.RELEVANTSPECIALDOC.length) {
                        initRelSubjectGroup($scope.list.RELEVANTSPECIALDOC[i]);
                    }
                });
            }
        }

        /**
         * [initKeyWords description]初始化关键词
         * @return {[type]} [description]
         */
        function initKeyWords() {
            if ($scope.list.KEYWORDS !== '') {
                var KEYWORDS = $scope.list.KEYWORDS.split(';');
                $scope.data.KEYWORDS = [];
                angular.forEach(KEYWORDS, function (data, index, array) {
                    $scope.data.KEYWORDS.push({
                        name: data,
                    });
                });
            } else {
                $scope.data.KEYWORDS = [];
            }
        }

        /**
         * [getVersion description] 获取流程版本与操作日志
         *
         * @param   {[type]}  id  [id description]
         *
         * @return  {[type]}      [return description]
         */
        function getVersion(id) {
            var defer = $q.defer();
            var metadataid = angular.isDefined(id) ? id : $state.params.appmetadataid;
            metadataid = $state.params.iwometadataid ? $state.params.iwometadataid : metadataid;
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(
                function (data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    $scope.status.hasVersionTime = true;
                    $scope.data.lastVersionid = data.lastVersionid;
                    defer.resolve();
                },
                function () {
                    defer.resolve();
                }
            );
            return defer.promise;
        }

        /**
         * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
         * @param  {[type]}  key [description] 操作日志或流程版本的数据
         * @return {Boolean}     [description]
         */
        $scope.isShowVersion = function (key) {
            if (key === undefined) {
                return false;
            } else {
                for (var i in key) {
                    return true;
                }
                return false;
            }
        };

        /**
         * [getPropagandaReview description] 宣传部流程
         * @return  {[type]}  [return description]
         */
        function getPropagandaReview() {
            var deffer = $q.defer();
            editingCenterService.getPropagandaReview(1, $state.params.appmetadataid).then(function (data) {
                $scope.data.propagandaReview = data;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [reWriteImg description]回写图片列表数据
         * @return {[type]} [description]
         */
        function reWriteImg() {
            var imgArray = ['LISTPICS', 'FOCUSIMAGE'];
            angular.forEach(imgArray, function (data, index) {
                if ($scope.list[data] !== 0) {
                    var arrayDocPic = [];
                    angular.forEach($scope.list[data], function (dataC, indexC) {
                        arrayDocPic.push({
                            APPFILE: dataC.APPFILE,
                            APPDESC: dataC.APPDESC,
                            PERPICURL: dataC.PERPICURL,
                        });
                    });
                    $scope.list[data] = arrayDocPic;
                }
            });
        }

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            editingCenterService.allAppCloseWindow($scope, { typeName: 'app', saveLocal: true, hascondition: true });
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function () {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.audioForm.$error) {
                errorArray.push(error);
            }
            $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
            if ($scope.status.newsFormError.length !== errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.newsFormError = errorArray;
            }
            return $scope.status.newsFormError; // 返回
        };

        /**
         * [getCutPictureWidthHeight description]获取图片编辑默认宽高
         * @return {[type]} [description]
         */
        function getCutPictureWidthHeight() {
            editingCenterService.querySettedPicSize('app').then(function (data) {
                var pictureSizeArr = ['TOPSIZE', 'TOPBIGSIZE', 'FOCUSIMAGESIZE', 'TOPZTPICSIZE'];
                var pictureSizeObj = editingCenterAppService.resetPicSize(pictureSizeArr, data);
                // 将返回来的值进行复制到本身控制器里显示
                dealPictureSize(pictureSizeArr, pictureSizeObj);
            });
            if (!$scope.data.imgSize && $scope.list) {
                changeMode($scope.list.LISTSTYLE || '0');
            }
        }

        /**
         * [dealPictureSize description]处理图片返回的比例操作
         *
         * @param   {[type]}  pictureSizeArr  [pictureSizeArr description]
         * @param   {[type]}  pictureSizeObj  [pictureSizeObj description]
         *
         * @return  {[type]}                  [return description]
         */
        function dealPictureSize(pictureSizeArr, pictureSizeObj) {
            pictureSizeArr.forEach(function (value, item) {
                $scope.status.pictureSize[value] = pictureSizeObj[value];
            });
            $scope.data.listPicRatio.set = pictureSizeObj.ratio.TOPSIZE;
            $scope.data.focusRatio.set = pictureSizeObj.ratio.FOCUSIMAGESIZE;
            $scope.data.bigPicRtion.set = pictureSizeObj.ratio.TOPBIGSIZE;
            $scope.data.specZtPicRtion.set = pictureSizeObj.ratio.TOPZTPICSIZE;
        }

        /**
         * [initBtnArray description] 初始化按钮
         * @return {[type]} [description]
         */
        function initBtnArray() {
            if ($scope.status.isawaitrevise) {
                // 待修订状态的编辑页只有保存按钮和修订按钮，在此处加入保存按钮
                addBtn();
                return;
            }
            // 所需的按钮
            $scope.data.appRequiredBtns = initAppRequiredBtnService.initAppRequiredBtns()[$state.params.appplatform];
            // 根据不同平台调用不同权限方法
            $scope.data.rightsMethod = ['app.daibian', 'app.daishen', 'app.yiqianfa'];
            initeditctrBtnsService.initAppData($state.params.appchannelid, $scope.data.rightsMethod[$state.params.appplatform]).then(function (data) {
                // 字典按钮
                $scope.data.dictionaryBtn = [
                    appDictionaryBtnService.initAppCompBtn(),
                    appDictionaryBtnService.initAppPendBtn(),
                    appDictionaryBtnService.initAppSignBtn(),
                ];
                initeditctrBtnsService.initBtns(data, $scope.data.dictionaryBtn[$state.params.appplatform]).then((btns) => {
                    $scope.status.btnStatus = btns;
                    // 最终得到的按钮
                    $scope.data.arrayBtn = filterEditctrBtnsService.filterBtn($scope.status.btnStatus, $scope.data.appRequiredBtns);
                    checkSiteCanSaveAndPub().then(function () {
                        addBtn();
                    });
                });
            });
        }

        /**
         * [initNewData description] 初始化新页面
         * @return {[type]} [description]
         */
        function initNewData() {
            var defer = $q.defer();
            editingCenterAppService.initTag($state.params.appsiteid).then(function (list) {
                $scope.list = initAddMetaDataService.initAudio();
                $scope.list.LABEL = list.length === 0 ? '' : list[0].value;
                $scope.list.LISTSTYLE = 0;
                $scope.list.ORIGINAL = '0';
                loadDirective().then(function () {
                    defer.resolve();
                });
            });
            return defer.promise;
        }

        /**
         * [loadDirective description] 加载相关组件
         * @return {[type]} [description]
         */
        function loadDirective() {
            var defer = $q.defer();
            if (!$state.params.issave || $state.params.issave === '0') {
                getBtnRights()
                    .then(function () {
                        return getSiteConfig();
                    })
                    .then(function (data) {
                        $scope.status.newFeatures = data.APPMODULEID === undefined ? '' : data.APPMODULEID; // app编辑器新功能；分别为 插入导语 插入组件 插入官员/话题 预览
                        $scope.status.setFont = {
                            // app编辑器设置字体大小 类型 行距 功能
                            fontFamilyCustom: data.TYPEFACEDEFINITION == '1',
                            fontSize: angular.isDefined(data.EDITORWORDS) ? data.EDITORWORDS.value : '12px',
                            lineSpacing: angular.isDefined(data.ROWSPACINGSETTING) ? data.ROWSPACINGSETTING.value : '1.75',
                        };
                        LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function () {
                            var ueditor =
                                '<ueditor-for-app edit-flag="editFlag" save="previewSave()" form="audioForm" type="{{\'app\'}}" draft-type="video" picture-size="data.imgSize"  new-features="status.newFeatures" set-font="status.setFont" versionid = "data.lastVersionid" list="list" infullscreen="status.infullscreen" authority="status.btnRights" has-content="status.hasContent"></ueditor-for-app>';
                            ueditor = $compile(ueditor)($scope);
                            $element.find('ueditorLocation').append(ueditor);
                            $scope.status.support.content = $scope.list.CONTENT;
                            $timeout(function () {
                                defer.resolve();
                            }, 1500);
                            editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
                            var draftList =
                                '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="videoForm"></editor-dir>' +
                                '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0"></editor-auth-dir>';
                            draftList = $compile(draftList)($scope);
                            $element.find('editor').append(draftList);
                        });
                    });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        /**
         * [getBtnRights description] 获取原子权限
         * @return {[type]} [description]
         */
        function getBtnRights() {
            var defer = $q.defer();
            if ($scope.status.isawaitrevise) {
                editcenterRightsService.initIwoListBtn('iwo.xiuding').then(function (rights) {
                    $scope.status.btnRights = rights;
                    defer.resolve();
                });
            } else {
                var rightType = ['app.daibian', 'app.daishen', 'app.yiqianfa'];
                editcenterRightsService.initAppListBtn(rightType[$state.params.appplatform], $state.params.appchannelid).then(function (rights) {
                    $scope.status.btnRights = rights;
                    defer.resolve();
                });
            }
            return defer.promise;
        }

        /**
         * [getSiteConfig description]获取站点的配置信息
         * @return {[type]}           [description]
         */
        function getSiteConfig() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_appmetadata',
                methodname: 'findAppSiteById',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.status.manuAttr = {
                    relatedTopic: data.RELATEDTOPIC,
                    connectionColumn: data.CONNECTIONCOLUMN,
                    relatedOfficial: data.RELATEDOFFICIAL,
                };
                initRelatedColumnData();
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [closeRelatedOfficial description] 关闭相关官员选项
         * @return {[type]} [description]
         */
        $scope.closeRelatedOfficial = function () {
            if (!$scope.status.relatedOfficial) {
                $scope.status.relatedOfficial = true;
                if (!angular.isArray($scope.data.selectedOfficial)) {
                    return;
                }
                $scope.list.RELEVANTOFFICIALSIDS = $scope.data.selectedOfficial.map((item) => item.id + '');
            } else {
                $scope.status.relatedOfficial = false;
                $scope.list.RELEVANTOFFICIALSIDS = [];
            }
        };

        /**
         * [selectedOfficials description] 选中了相关官员
         * @return {[type]} [description]
         */
        $scope.selectedOfficials = function () {
            $scope.list.RELEVANTOFFICIALSIDS = $scope.data.selectedOfficial.map((item) => item.id + '');
        };

        /**
         * [initRelatedColumnData description] 初始化相关栏目数据，以适应级联菜单
         * @return {[type]} [description]
         */
        function initRelatedColumnData() {
            if ($scope.status.manuAttr.connectionColumn == 1) {
                $scope.status.relatedColumn = [
                    [
                        {
                            name: $scope.list.BELONGCHANNEL.TYPE,
                            id: $scope.list.BELONGCHANNEL.ID,
                        },
                        {
                            name: $scope.list.BELONGCHANNEL.NAME,
                            id: $scope.list.BELONGCHANNEL.VALUE,
                        },
                    ],
                ];
            }
        }

        /**
         * [getZJXWColumns description] 获取相关栏目列表
         * @return {[type]} [description]
         */
        $scope.getZJXWColumns = function () {
            let deffer = $q.defer();
            let params = {
                serviceid: 'mlf_appexchange',
                methodname: 'getZJXWColumns',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                let treeData = (() => {
                    if (
                        !angular.isObject(resp) ||
                        !angular.isObject(resp.DATA) ||
                        !angular.isArray(resp.DATA.all_columns) ||
                        resp.DATA.all_columns.length == 0
                    ) {
                        return [];
                    }
                    return resp.DATA.all_columns.map((item, index) => ({
                        id: item.id,
                        name: item.type,
                        CHILDREN: item.column_list.map((item_, index_) => {
                            item_.hasChildren = 0;
                            return item_;
                        }),
                    }));
                })();
                deffer.resolve(treeData);
            });
            return deffer.promise;
        };

        /**
         * [selectRelatedColumn description] 选中相关栏目
         * @return {[type]} [description]
         */
        $scope.selectRelatedColumn = function () {
            $scope.list.BELONGCHANNEL =
                angular.isArray($scope.status.relatedColumn) &&
                    angular.isArray($scope.status.relatedColumn[0]) &&
                    $scope.status.relatedColumn[0][1].id
                    ? {
                        ID: $scope.status.relatedColumn[0][0].id,
                        TYPE: $scope.status.relatedColumn[0][0].name,
                        NAME: $scope.status.relatedColumn[0][1].name,
                        VALUE: $scope.status.relatedColumn[0][1].id,
                    }
                    : {};
        };

        /**
         * [checkSiteCanSaveAndPub description] 校验站点是否设置了不显示“保存并发布”按钮
         * @return {[type]} [description]
         */
        function checkSiteCanSaveAndPub() {
            var defer = $q.defer();
            if ($state.params.appplatform == 2) {
                var params = {
                    serviceid: 'mlf_appconfig',
                    methodname: 'canSaveAndPub',
                    SiteId: $state.params.appsiteid,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    var isNotShow = data.substring(1, data.indexOf('"', 1));
                    if (isNotShow == 'true') {
                        var hasPubSave = false;
                        var hasPubSaveIndex;
                        angular.forEach($scope.data.arrayBtn, function (value, key) {
                            // 判断是否含有保存并发布按钮
                            if (value.RIGHTINDEX == 419) {
                                hasPubSave = true;
                                hasPubSaveIndex = key;
                            }
                        });
                        if (hasPubSave === true) {
                            // 在已签发平台删除保存并发布按钮
                            $scope.data.arrayBtn.splice(hasPubSaveIndex, 1);
                        }
                    }
                    defer.resolve();
                });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        /**
         * [addBtn description]
         *
         * @return  {[type]}  [return description]
         */
        function addBtn() {
            $scope.data.arrayBtn = $scope.data.arrayBtn ? $scope.data.arrayBtn : [];
            var OPERDESC = ['保存', '保存'];
            var OPERFUN = ['save', 'save'];
            if ($state.params.appplatform < 2) {
                $scope.data.arrayBtn.unshift({
                    RIGHTINDEX: 'save',
                    OPERDESC: OPERDESC[$state.params.appplatform],
                    OPERNAME: '',
                    OPERFUN: OPERFUN[$state.params.appplatform],
                });
            }
        }

        /**
         * [handleBtnClick description] 绑定按钮点击事件
         * @param  {[type]} funname [description]
         * @return {[type]}         [description]
         */
        $scope.handleBtnClick = function (funname) {
            eval('$scope.' + funname + '()');
        };

        /**
         * [updateCKSelection description] 复选框的回调函数
         * @param  {[type]} attribute [description]
         * @return {[type]}           [description]
         */
        $scope.updateCKSelection = function (attribute) {
            // if (attribute === 'ISFOCUSIMAGE' && $state.params.appplatform === '2') {
            //     modalDialog.alertType('', '稿件已签发后，无法勾选或取消勾选栏目焦点图', 'error', false, function() {});
            //     return;
            // }
            $scope.list[attribute] = $scope.list[attribute] == '0' ? '1' : '0';
        };

        /**
         * [deleteUploaderImg description]删除上传后的图片
         * @param  {[str]} attribute [description]要删除的属性
         * @param  {[num]} index     [description]下标
         * @return {[type]}           [description]
         */
        $scope.deleteUploaderImg = function (attribute, index) {
            if (attribute === 'LISTPICS') {
                $scope.list[attribute][index] = {
                    APPFILE: '',
                    APPDESC: '',
                    PERPICURL: '',
                };
            } else {
                $scope.list[attribute] = [];
            }
        };

        /**
         * [invalidTag description] 检验关键词的总个数和总记录长度
         * @param  {[type]} tag [description]
         * @return {[type]}     [description]
         */
        $scope.invalidTag = function (tag) {
            var reg = /^[^<>\/;]*$/;
            if (tag.name.length > 20) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '单个关键词长度不能超过20！';
            }
            if (!reg.test(tag.name)) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '不能包含特殊字符！';
            }
        };

        $scope.checkTag = function (tag) {
            var len = $scope.data.KEYWORDS.length;
            if (len == 10) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '关键词个数不能超过10个！';
                return false;
            } else {
                $scope.keywordsTips = '';
                $scope.isShowKeywordTips = false;
            }
            if (tag.name.indexOf(' ') > -1) {
                var spaceArr = tag.name.split(' ');
                $timeout(function () {
                    $scope.data.KEYWORDS.pop();
                    var containArr = [];
                    for (var j = 0; j < $scope.data.KEYWORDS.length; j++) {
                        containArr.push($scope.data.KEYWORDS[j].name);
                    }
                    for (var i = 0; i < spaceArr.length; i++) {
                        if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                            $scope.data.KEYWORDS.push({ name: spaceArr[i] });
                            containArr.push(spaceArr[i]);
                        }
                    }
                });
            }
        };

        $scope.leave = function () {
            // $scope.isShowKeywordTips = false;
        };

        $scope.enter = function () {
            var reg = /^[^<>\/]*$/;
            if (angular.isDefined($scope.KEYWORDTEXT) && (!reg.test($scope.KEYWORDTEXT) || $scope.KEYWORDTEXT.length > 20)) {
                $scope.isShowKeywordTips = true;
            }
        };

        /**
         * [getKeywordsOrAbstract description]提取关键词或摘要
         * @param  {[str]} type [description]关键词类型或摘要
         * @return {[type]}      [description]
         */
        $scope.getKeywordsOrAbstract = function (type) {
            editingCenterService.getKeywordsOrAbstract(type, ueditorService.bindContent()).then(
                function (data) {
                    if (type === 'keywords') {
                        if (data !== '""') {
                            var arr = [];
                            var keywordsArray = data.substring(1, data.length - 1).split(';');
                            angular.forEach(keywordsArray, function (value, key) {
                                arr.push({
                                    name: value,
                                });
                            });
                            $scope.data.KEYWORDS = angular.isArray($scope.data.KEYWORDS) ? $scope.data.KEYWORDS : [];
                            $scope.data.KEYWORDS = $scope.data.KEYWORDS.concat(arr);
                            $scope.data.KEYWORDS = $filter('unique')($scope.data.KEYWORDS, 'name');
                            if ($scope.data.KEYWORDS.length > 10) {
                                $scope.data.KEYWORDS = $scope.data.KEYWORDS.splice(0, 10);
                            }
                        } else {
                            return;
                        }
                    }
                    if (type === 'abstract') {
                        $scope.list.ABSTRACT = data.substring(1, data.length - 1);
                    }
                },
                function (data) { }
            );
        };

        /**
         * [clearAllKeywords description]清除所有关键词
         * @return {[type]} [description]
         */
        $scope.clearAllKeywords = function () {
            $scope.data.KEYWORDS = [];
        };

        /**
         * [visualChooseWindow description] 可视化选择弹窗
         * @param  {[type]} type [description]
         * @return {[type]}      [description]
         */
        $scope.visualChooseWindow = function (type) {
            trsSelectDocumentService.trsSelectDocument(
                {
                    siteid: $state.params.appsiteid,
                    relNewsData: type == 'relSubjectSelectedItems' ? [] : angular.copy($scope.data[type]),
                    position: $state.params.appplatform,
                    showMetadaId: true,
                    isApp: true,
                    docType: '7',
                    searchSpecialDoc: type == 'relSubjectSelectedItems',
                    platform: 7,
                },
                function (result) {
                    if (type == 'relNewsSelectedItems') {
                        angular.forEach(result, function (value, key) {
                            value.METADATAID = value.metadataId;
                            value.LISTTITLE = value.title;
                        });
                        $scope.data[type] = result;
                    } else {
                        var i = 0;
                        var index = $scope.data[type].length;
                        var hasGroupArray = [];
                        queryRelSubjectGroup(result[i], function () {
                            $scope.data[type] = $scope.data[type].concat(hasGroupArray);
                        });
                    }

                    /**
                     * [queryRelSubjectGroup description] 请求相关专题稿件的分组
                     * @param  {[type]}   item     [description] 当前稿件
                     * @param  {Function} callback [description] 回调函数
                     * @return {[type]}            [description]
                     */
                    function queryRelSubjectGroup(item, callback) {
                        item.METADATAID = item.metadataId;
                        item.LISTTITLE = item.title;
                        var params = {
                            methodname: 'querySpecialGroupsFromData',
                            serviceid: 'mlf_specialgroup',
                            MetaDataId: item.METADATAID,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                            if (data.DATA.length === 0) {
                                modalDialog.alertType('相关专题"' + item.LISTTITLE + '"没有分组', '', 'error', 'confirm');
                                i++;
                            } else {
                                $scope.data.relSubjectGroup[index] = data.DATA;
                                angular.forEach($scope.data.relSubjectGroup[index], function (value, key) {
                                    value.name = value.SPECIALGROUPNAME;
                                    value.value = value.SPECIALGROUPID;
                                });
                                $scope.data.relSubjectSelectedGroup[index] = $scope.data.relSubjectGroup[index][0];
                                item.SPECIALGROUPID = $scope.data.relSubjectGroup[index][0].SPECIALGROUPID;
                                hasGroupArray.push(item);
                                i++;
                                index++;
                            }
                            if (i < result.length) {
                                queryRelSubjectGroup(result[i], callback);
                            } else {
                                callback();
                            }
                        });
                    }
                }
            );
        };

        /**
         * [queryRelatedNewsByKeyWords description] 匹配关联稿件
         * @return {[type]} [description]
         */
        $scope.queryRelatedNewsByKeyWords = function () {
            var DocId = $state.params.appmetadataid ? $state.params.appmetadataid : 0;
            var keywords = [];
            keywords = trsspliceString.spliceString(angular.copy($scope.data.KEYWORDS), 'name', ';');
            if (!keywords) {
                modalDialog.alertType('暂无关联稿件', '', 'warning', false);
                return;
            }
            var params = {
                serviceid: 'mlf_appmetadata',
                methodname: 'queryRelatedNewsByKeyWords',
                MetaDataId: DocId,
                ChannelId: $state.params.appchannelid,
                KeyWords: keywords,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                var ralNewsLen = angular.copy($scope.data.relNewsSelectedItems).length;
                if (ralNewsLen >= 5) {
                    return;
                }
                $scope.data.relNewsSelectedItems = darftRemove($scope.data.relNewsSelectedItems, data, 'METADATAID').splice(0, 5);
                if ($scope.data.relNewsSelectedItems.length == 0) {
                    modalDialog.alertType('暂无关联稿件', '', 'warning', false);
                }
            });
        };

        /**
         * [darftRemove description] 数组去重
         * @param   {[type]}  selectArray  [selectArray description] 当前数组
         * @param   {[type]}  dataArray    [dataArray description] 再次请求出数组
         * @param   {[type]}  type         [type description]
         * @param   {[type]}  callback     [callback description]
         * @return  {[type]}               [return description]
         */
        function darftRemove(selectArray, dataArray, type, callback) {
            var arr = selectArray.concat(dataArray);
            var lastArr = [];
            var num = 0;
            for (var i = 0; i < arr.length; i++) {
                if (!unique(arr[i][type], lastArr, type)) {
                    lastArr.push(arr[i]);
                } else {
                    if (angular.isFunction(callback)) {
                        callback(i - num);
                        num++;
                    }
                }
            }
            return lastArr;
        }

        /**
         * [unique description]
         * @param   {[type]}  n     [n description]
         * @param   {[type]}  arr   [arr description]
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        function unique(n, arr, type) {
            for (var i = 0; i < arr.length; i++) {
                if (n == arr[i][type]) {
                    return true;
                }
            }
            return false;
        }

        /**
         * [selectManuscript description] 选择相关新闻或专题
         *
         * @param   {[type]}  item  [item description]
         * @param   {[type]}  type  [type description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.selectManuscript = function (item, type) {
            if (type === 'relNewsSelectedItems') {
                if ($scope.data.selectNewArray.indexOf(item) < 0) {
                    $scope.data.selectNewArray.push(item);
                } else {
                    $scope.data.selectNewArray.splice($scope.data.selectNewArray.indexOf(item), 1);
                }
            } else {
                if ($scope.data.selectSubjectArray.indexOf(item) < 0) {
                    $scope.data.selectSubjectArray.push(item);
                } else {
                    $scope.data.selectSubjectArray.splice($scope.data.selectSubjectArray.indexOf(item), 1);
                }
            }
        };

        /**
         * [selectAll description] 稿件全选
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.selectAll = function (type) {
            if (type === 'selectSubjectArray') {
                $scope.data.selectSubjectArray =
                    $scope.data.selectSubjectArray.length == $scope.data.relSubjectSelectedItems.length
                        ? []
                        : [].concat($scope.data.relSubjectSelectedItems);
            } else {
                $scope.data.selectNewArray =
                    $scope.data.selectNewArray.length == $scope.data.relNewsSelectedItems.length ? [] : [].concat($scope.data.relNewsSelectedItems);
            }
        };

        /**
         * [manuscriptDelete description]
         * @param   {[type]}  type  [type description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.manuscriptDelete = function (type) {
            var index;
            if (type === 'relSubjectSelectedItems') {
                for (var i = 0; i < $scope.data.selectSubjectArray.length; i++) {
                    index = $scope.data.relSubjectSelectedItems.indexOf($scope.data.selectSubjectArray[i]);
                    $scope.data.relSubjectSelectedItems.splice(index, 1);
                }
                $scope.data.selectSubjectArray.length = 0;
            } else {
                for (var i = 0; i < $scope.data.selectNewArray.length; i++) {
                    index = $scope.data.relNewsSelectedItems.indexOf($scope.data.selectNewArray[i]);
                    $scope.data.relNewsSelectedItems.splice(index, 1);
                }
                $scope.data.selectNewArray.length = 0;
            }
        };

        /**
         * [selectRelSubjectGroup description] 选择相关专题稿件的分组
         * @param   {[type]}  item           [item description]
         * @param   {[type]}  selectedGroup  [selectedGroup description]
         * @return  {[type]}                 [return description]
         */
        $scope.selectRelSubjectGroup = function (item, selectedGroup) {
            item.SPECIALGROUPID = selectedGroup.value;
        };

        /**
         * [cleanRelatedNews description] 清空相关联稿件
         * @param  {[type]} type [description]
         * @return {[type]}      [description]
         */
        $scope.cleanRelatedNews = function (type) {
            $scope.data[type] = [];
            if (type === 'relSubjectSelectedItems') {
                $scope.data.relSubjectGroup = [];
                $scope.data.relSubjectSelectedGroup = [];
            }
        };

        /**
         * [relNewsDelete description] 删除相关新闻或专题
         * @param  {[type]} curIndex [description]
         * @param  {[type]} type     [description]
         * @return {[type]}          [description]
         */
        $scope.relNewsDelete = function (curIndex, type) {
            var index = $scope.data[type].indexOf(curIndex);
            $scope.data[type].splice(index, 1);
            if (type === 'relSubjectSelectedItems') {
                $scope.data.relSubjectGroup.splice(index, 1);
                $scope.data.relSubjectSelectedGroup.splice(index, 1);
            }
        };

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getVersion();
        };

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function (item) {
            var path = $scope.data.path[item.MEDIATYPE];
            var params = {
                objectversionid: item.OBJECTVERSIONID,
                chnldocid: $state.params.appchnldocid,
            };
            var url = $state.href(path, params);
            item.url = url;
        };

        /**
         * [save description] 保存稿件
         * @param  {[type]} type [description] 是否直接保存
         * @return {[type]}      [description]
         */
        $scope.save = function (type) {
            // 包含本地版本功能的稿件类型做了特殊处理，在进行其他操作时均先做此保存操作，以此来更新本地版本
            type = angular.isDefined(type) ? type : true;
            var deffer = $q.defer();
            if (!$scope.list.VIDEOREL.length) {
                var info = $scope.status.uploadOrChage === 'change' ? '请等待转换完成' : '需要上传一个音频';
                modalDialog.alertType('保存失败', info, 'warning', false);
                deffer.reject();
                return deffer.promise;
            }
            save(type).then(
                function () {
                    if (!$scope.$root.cureditpage || $scope.$root.cureditpage === 'appvideo') {
                        if (type === true) {
                            editIsLock.lockDraft($state.params.appmetadataid);
                        }
                        getVersion($scope.list.METADATAID).then(function () {
                            var params = {
                                serviceid: 'mlf_appmetadata',
                                methodname: 'getVideoDoc',
                                ChnlDocId: $state.params.appchnldocid,
                            };
                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                                var ue = UE.getEditor('ueditor');
                                ue.ready(function () {
                                    ue.setContent(data.HTMLCONTENT);
                                    ueditorService.saveToLocal($scope.list.METADATAID, 'app', data.HTMLCONTENT, $scope.data.lastVersionid);
                                    deffer.resolve(data);
                                });
                            });
                        });
                    } else {
                        getVersion($scope.list.METADATAID).then(function () {
                            ueditorService.saveToLocal($scope.list.METADATAID, 'app', $scope.list.HTMLCONTENT, $scope.data.lastVersionid);
                        });
                        deffer.resolve();
                    }
                },
                function () {
                    deffer.reject();
                }
            );
            return deffer.promise;
        };

        /**
         * [previewSave description]预览前保存，用于编辑器预览
         * @return {[type]} [description]
         */
        $scope.previewSave = function () {
            var deffer = $q.defer();
            $scope.save(false).then(function (data) {
                $scope.status.openBtn = true;
                $state.params.appchnldocid = $scope.list.CHNLDOCID = data.CHNLDOCID;
                $state.params.appmetadataid = $scope.list.METADATAID = data.METADATAID;
                storageListenerService.addListenerToApp('save');
                $state.transitionTo($state.current, $state.params, {
                    reload: false,
                });
                editIsLock.lockDraft($state.params.appmetadataid);
                deffer.resolve(data);
            });
            // });
            return deffer.promise;
        };

        /**
         * [appPreview description]稿件预览
         * @return {[type]} [description]
         */
        $scope.appPreview = function () {
            $scope.save(false).then(function (data) {
                editIsLock.lockDraft($state.params.appmetadataid);
                mobilePreview();
            });
        };

        /**
         * [mobilePreview description]手机端预览方法
         * @return {[type]} [description]
         */
        function mobilePreview() {
            $scope.loadingPromise = editingCenterAppService.appPrevewPublish($state.params.appchnldocid).then(
                function () { },
                function () {
                    editIsLock.lockDraft($state.params.appmetadataid);
                }
            );
        }

        /**
         * [save description]保存方法
         * @param  {[boolean]} flag [description]标示位
         * @return {[type]}      [description]
         */
        function save(flag) {
            var deferred = $q.defer();
            $scope.status.isedit = !!$state.params.appmetadataid;
            saveContent();
            $scope.audioForm.$pending = {};
            $validation
                .validate($scope.audioForm)
                .success(function () {
                    editingCenterAppService.examineImageRatio($scope.list, $scope.data, $scope.status, 'TOPSIZE', 'TOPBIGSIZE', 'TOPZTPICSIZE').then(function () {
                        modalDialog.isSecretInformation(
                            $state.params.appmetadataid,
                            function () {
                                sensitiveWordCheckService.sensitiveWords($scope).then(
                                    function (sensitiveWords) {
                                        $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                        $scope.list.SENSITIVEWORDS = sensitiveWords;
                                        $scope.audioForm.$setPristine();
                                        var list = dealAttributeBeforeSave();
                                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                            function (data) {
                                                $scope.data.METADATAID = data.METADATAID;
                                                if (!$scope.status.isedit) {
                                                    $scope.status.isedit = false;
                                                } else {
                                                    $scope.status.isedit = true;
                                                }
                                                dealAttributeAfterSave(data, flag);
                                                beforeonload.refresh($scope);
                                                deferred.resolve(data);
                                            },
                                            function (data) {
                                                $scope.status.openBtn = true;
                                                deferred.reject(data);
                                            }
                                        );
                                    },
                                    function () {
                                        $scope.status.isCheckSensitiveWords = Math.random();
                                        deferred.reject();
                                    }
                                );
                            },
                            function () {
                                deferred.reject();
                            },
                            false
                        );
                    });
                })
                .error(function () {
                    editingCenterService.checkSaveError($scope.audioForm, $element, $scope); // 定位输入错的表单位置
                    deferred.reject();
                });
            return deferred.promise;
        }

        /**
         * [saveContent description]保存正文
         * @return {[type]} [description]
         */
        function saveContent() {
            ueditorService.saveContent($scope.list);
            if ($scope.list.HTMLCONTENT === '') {
                $timeout(function () {
                    // 表单校验手动触发
                    $scope.audioForm.content.$error.content = true;
                    $scope.audioForm.content.$valid = false;
                    $scope.audioForm.content.$invalid = true;
                    $scope.audioForm.$error.content = [$scope.audioForm.content];
                    $scope.audioForm.$valid = false;
                    $scope.audioForm.$invalid = true;
                });
            }
        }

        /**
         * [dealAttributeBeforeSave description]保存前处理保存属性
         * @return {[obj]} [description]list对象
         */
        function dealAttributeBeforeSave() {
            $scope.status.openBtn = false;
            getKeyWords();
            $scope.list.RELATEDNEWS = trsspliceString.spliceString($scope.data.relNewsSelectedItems, 'METADATAID', ',');
            $scope.list.VIDEOID = $scope.list.VIDEOREL[0].AUDIOVIDEOID; // 兼容后端videoid不返回bug
            getRelavantSpecialDoc();
            var list = angular.copy($scope.list);
            // 处理发稿单作者信息空数据提交问题
            if (
                angular.isDefined(list.FGD_AUTHINFO[0]) &&
                (!angular.isDefined(list.FGD_AUTHINFO[0].USERNAME) || list.FGD_AUTHINFO[0].USERNAME === '')
            ) {
                list.FGD_AUTHINFO = [];
            }
            list.CONTRIBUTORSAUTHER = $scope.data.userName;
            list.ORIGINALTYPE = $scope.data.originType;
            list.SPECIALDOC = $scope.data.specialDoc;
            // 处理发稿单作者信息空数据提交问题
            list.serviceid = 'mlf_appmetadata';
            list.methodname = 'saveAudioDoc';
            list = jsonArrayToStringService.jsonArrayToString(list);
            return list;
        }

        /**
         * [getRelavantSpecialDoc description] 获取相关专题
         * @return {[type]} [description]
         */
        function getRelavantSpecialDoc() {
            darftRemove($scope.data.relSubjectSelectedItems, [], 'SPECIALGROUPID', function (index) {
                $scope.data.relSubjectSelectedItems.splice(index, 1);
                $scope.data.relSubjectGroup.splice(index, 1);
                $scope.data.relSubjectSelectedGroup.splice(index, 1);
            });
            $scope.list.RELEVANTSPECIALDOC = [];
            angular.forEach($scope.data.relSubjectSelectedItems, function (data, index) {
                $scope.list.RELEVANTSPECIALDOC.push({
                    METADATAID: data.METADATAID,
                    SPECIALGROUPID: data.SPECIALGROUPID,
                });
            });
            $scope.list.RELEVANTSPECIALDOC = jsonArrayToStringService.clearEmptyArray($scope.list.RELEVANTSPECIALDOC);
        }

        /**
         * [getKeyWords description]获取关键词
         * @return {[type]} [description]
         */
        function getKeyWords() {
            $scope.list.KEYWORDS = '';
            angular.forEach($scope.data.KEYWORDS, function (data, index, array) {
                if (index != $scope.data.KEYWORDS.length - 1) {
                    $scope.list.KEYWORDS += data.name + ';';
                } else {
                    $scope.list.KEYWORDS += data.name;
                }
            });
        }

        /**
         * [dealAttributeAfterSave description]保存成功后处理属性
         * @param  {[obj]} data [description]保存后后台返回值
         * @param  {[boolean]} flag [description]标识位
         * @return {[type]}      [description]
         */
        function dealAttributeAfterSave(data, flag) {
            $scope.status.openBtn = true;
            $scope.status.isEditDraft = true;
            $state.params.appchnldocid = $scope.list.CHNLDOCID = data.CHNLDOCID;
            $state.params.appmetadataid = $scope.list.METADATAID = data.METADATAID;
            if (flag) {
                storageListenerService.addListenerToApp('save');
                $state.transitionTo($state.current, $state.params, {
                    reload: false,
                });
                $timeout(function () {
                    modalDialog.saveModel('保存成功', '', 'success');
                }, 500);
            } else {
                $scope.params.MetaDataIds = $scope.list.METADATAID;
                $scope.params.CHNLDOCIDS = $scope.list.CHNLDOCID;
                $scope.params.ObjectIds = $scope.list.CHNLDOCID;
                $scope.params.serviceid = 'mlf_appoper';
            }
        }

        /**
         * [appTrial description]APP送审操作
         * @return {[type]} [description]
         */
        $scope.appTrial = function () {
            trial();
        };

        /**
         * [trial description]稿件送审
         * @return {[type]} [description]
         */
        function trial() {
            newMediaService.trial($scope, appConst.params.trialParams).then((opinion) => {
                $scope.save(false).then(function () {
                    let trialParams = angular.extend({
                        MetaDataIds: $scope.list.METADATAID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        ChannelId: $state.params.appchannelid,
                        Opinion: opinion,
                    }, appConst.params.trialParams);
                    messagePublishService.publish('doEditPageOperation', trialParams);
                });
            });
        }

        /**
         * [appSignDirect description]app直接签发
         * @return {[type]} [description]
         */
        $scope.appSignDirect = function () {
            signDirect();
        };

        /**
         * [signDirect description]
         *
         * @param   {[type]}  isSaveAndPublish  [isSaveAndPublish description]
         *
         * @return  {[type]}                    [return description]
         */
        function signDirect(isSaveAndPublish) {
            var array = [$scope.list];
            if (isSaveAndPublish) {
                signPrivate();
                // mergeSign();
            } else {
                sensitiveWordCheckService.SensitiveWordsAndCareful(array, true, '1').then(
                    function () {
                        signPrivate();
                    },
                    function () {
                        signPrivate();
                        // mergeSign();
                    }
                );
            }
        }

        /**
         * [signPrivate description]
         *
         * @return  {[type]}  [return description]
         */
        function signPrivate() {
            var methodname = ['appDaiBianPublish', 'appDaiShenPublish', 'appYiQianFaPublish'];
            $scope.loadingPromise = newMediaService.sign($scope).then(function() {
                $scope.save(false).then(() => {
                    let signParams = {
                        serviceid: 'mlf_appoper',
                        methodname: methodname[$state.params.appplatform],
                        ObjectIds: $scope.list.CHNLDOCID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                    };
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        }

        /**
         * [appSignTiming description]定时签发
         * @return {[type]} [description]
         */
        $scope.appSignTiming = function () {
            if ($scope.status.isSecondReview === true) {
                modalDialog.alertType('无法进行操作', '该稿件处于二次送审流程中，不能定时签发', 'warning', 'confirm');
                return;
            }
            timeSign();
        };

        /**
         * [timeSign description]定时签发函数
         * @return {[type]} [description]
         */
        function timeSign() {
            var methodname = ['appDaiBianTimingPublish', 'appDaiShenTimingPublish'];
            $scope.loadingPromise = newMediaService.timeSign($scope).then(function() {
                $scope.save(false).then(() => {
                    let signParams = {
                        serviceid: 'mlf_appoper',
                        methodname: methodname[$state.params.appplatform],
                        ObjectIds: $scope.list.CHNLDOCID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                    };
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        }

        /**
         * [appRevoke description]稿件撤稿
         * @return {[type]} [description]
         */
        $scope.appRevoke = function () {
            revoke();
        };

        /**
         * [revoke description]撤稿函数
         * @return {[type]} [description]
         */
        function revoke() {
            newMediaService.rejection($scope, appConst.params.rejectionParams).then((opinion) => {
                $scope.save(false).then(function () {
                    let KillParams = angular.extend({
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                        Opinion: opinion,
                        ChannelId: $state.params.appchannelid,
                    }, appConst.params.rejectionParams);
                    messagePublishService.publish('doEditPageOperation', KillParams);
                });
            });
        }

        /**
         * [appSavePublish description]保存并发布
         * @return {[type]} [description]
         */
        $scope.appSavePublish = function () {
            signDirect(true);
        };

        /**
         * [appSecondReview description] 已签发平台二次送审
         * @return {[type]} [description]
         */
        $scope.appSecondReview = function () {
            if ($scope.status.isSecondReview === true) {
                modalDialog.alertType('无法进行操作', '该稿件处于二次送审流程中，不能重复送审', 'warning', 'confirm');
                return;
            }
            modalDialog.confirmModal('二次送审', '确认送审稿件', function () {
                appSecondReview();
            });
        };

        /**
         * [appSecondReview description] 二次送审函数(不做保存，但把保存方法里的稿件信息全部作为参数传过去)
         * @param  {[type]} metadataid [description]
         * @return {[type]}            [description]
         */
        function appSecondReview() {
            var ue = UE.getEditor('ueditor');
            saveContent();
            $scope.audioForm.$pending = {};
            $validation
                .validate($scope.audioForm)
                .success(function () {
                    sensitiveWordCheckService.sensitiveWords($scope).then(
                        function (sensitiveWords) {
                            $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                            $scope.list.SENSITIVEWORDS = sensitiveWords;
                            $scope.audioForm.$setPristine();
                            var list = dealAttributeBeforeSave();
                            list.serviceid = 'mlf_appoper';
                            list.methodname = 'makeNewDuplication';
                            list.MetaDataId = list.METADATAID;
                            list.ChannelId = list.CHANNELID;
                            delete list.METADATAID;
                            delete list.CHANNELID;
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                function (data) {
                                    if (data.ISSUCCESS == 'true') {
                                        getVersion($scope.list.METADATAID).then(function () {
                                            var params = {
                                                serviceid: 'mlf_appmetadata',
                                                methodname: 'getVideoDoc',
                                                ChnlDocId: $state.params.appchnldocid,
                                            };
                                            $scope.loadingPromise = trsHttpService
                                                .httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                                                .then(function (data) {
                                                    var ue = UE.getEditor('ueditor');
                                                    ue.ready(function () {
                                                        ue.setContent(data.HTMLCONTENT);
                                                        ueditorService.saveToLocal(
                                                            $scope.list.METADATAID,
                                                            'app',
                                                            data.HTMLCONTENT,
                                                            $scope.data.lastVersionid
                                                        );
                                                        modalDialog.alertType(
                                                            '二次送审成功',
                                                            '',
                                                            'success',
                                                            false,
                                                            function () {
                                                                $scope.status.isSecondReview = true;
                                                                storageListenerService.addListenerToApp('secondReview');
                                                                $window.close();
                                                            },
                                                            '',
                                                            1500
                                                        );
                                                    });
                                                });
                                        });
                                    } else {
                                        modalDialog.alertType('二次送审失败', '', 'error', 'confirm');
                                    }
                                },
                                function (data) {
                                    $scope.status.openBtn = true;
                                    modalDialog.alertType('二次送审失败', '', 'error', 'confirm');
                                }
                            );
                        },
                        function () {
                            $scope.status.isCheckSensitiveWords = Math.random();
                        }
                    );
                })
                .error(function () {
                    editingCenterService.checkSaveError($scope.audioForm); // 定位输入错的表单位置
                });
        }

        /**
         * [revise description] 修订
         * @return {[type]} [description]
         */
        $scope.revise = function () {
            modalDialog.confirmModal('修订', '确认修订?', function () {
                save().then(
                    function () {
                        var params = {
                            serviceid: 'mlf_modifydoc',
                            methodname: 'paperModifyDocsFinished',
                            PaperDocIds: $state.params.appmetadataid,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                            function (data) {
                                modalDialog.alertType(
                                    '修订成功',
                                    '',
                                    'success',
                                    false,
                                    function () {
                                        storageListenerService.addListenerToNewspaper('xiuding');
                                        $window.close();
                                    },
                                    '',
                                    1500
                                );
                            },
                            function (data) {
                                editIsLock.lockDraft($state.params.appmetadataid);
                            }
                        );
                    },
                    function () {
                        editIsLock.lockDraft($state.params.appmetadataid);
                    }
                );
            });
        };

        /**
         * [close description]关闭页面
         * @return {[type]} [description]
         */
        $scope.close = function () {
            closeCurrView();
        };

        /**
         * [closeCurrView description] 页面关闭
         * @return  {[type]}  [return description]
         */
        function closeCurrView() {
            editingCenterService
                .closeWinow($scope.audioForm.$dirty, ueditorService.contentTranscoding($scope.list) != ueditorService.bindContent())
                .then(
                    function () {
                        $scope.save(false).then(function () {
                            storageListenerService.addListenerToApp('save');
                            editIsLock.normalLock($state.params.appmetadataid).then(function (data) {
                                $window.open('about:blank', '_self').close();
                            });
                        });
                    },
                    function () {
                        angular.isDefined($state.params.appmetadataid)
                            ? editIsLock.normalLock($state.params.appmetadataid).then(function (data) {
                                $window.open('about:blank', '_self').close();
                            })
                            : $window.open('about:blank', '_self').close();
                    }
                );
        }

        /**
         * [getSuggestions description]获取suggestion
         * @param  {[str]} viewValue [description]输入框内输入值
         * @return {[type]}           [description]
         */
        $scope.getSuggestions = function (viewValue) {
            return editingCenterService.getRecentUsageSources(viewValue);
        };

        /**
         * [getVideoInfo description]获得视频详情
         * @return {[type]} [description]
         */
        function getVideoInfo() {
            editCenUploadVideoForXjService.getVideoMark($scope.list.VIDEOREL[0]).then(function (data) {
                $scope.uploader.fastVideoInfo = data;
                $scope.uploader.fastVideoInfo.status = editCenUploadVideoForXjService.videoDraftStatus[data.status];
                $scope.list.VIDEOREL[0].URL = data.videoUrl; // 回填URL
                $scope.list.VIDEOREL[0].ThumbImg = data.ThumbImg;
                if ($scope.uploader.fastVideoInfo.status === '转码中' || $scope.uploader.fastVideoInfo.status === '快编中') {
                    if (!$scope.data.fastVideoTimer) {
                        uploadAudioTimeout();
                    }
                } else {
                    $timeout.cancel($scope.uploader.fastVideoTimer);
                }
            });
        }

        /**
         * [uploadTest description]视频上传
         * @return {[type]} [description]
         */
        $scope.uploadTest = function () {
            $scope.uploader.uploaderOptions.showModal = false;
            $scope.status.uploadOrChage = 'upload'; // 表示视频上传状态
            let options = {
                resourceType: '1',
                isMulti: false
            };
            editingCenterService.mediaSelector(options).then(function (result) {
                for (var i = 0; i < result.list.length; i++) {
                    var file = result.list[i];
                    if (file.resourcestatus === 10) {
                        uploadAsync(file);
                    } else if (file.resourcestatus !== 10) {
                        $scope.uploader.fastVideoInfo.status = '转码完成';
                        $scope.list.VIDEOREL.push({
                            AUDIOVIDEOID: file.videoid,
                            URL: file.path || file.previewurl,
                            REMARKS: '',
                            PLATFORMFLAG: 'BDVideoObject',
                            ThumbImg: file.thumbimg,
                            relationId: file.relationid,
                            meiziId: file.resourceid
                        });
                    }
                    storgeVideoInfo(false, { datas: file });
                }
            });
        };

        /**
         * [deleteVideo description] 删除视频预览
         * @return {[type]} [description]
         */
        $scope.deleteVideo = function () {
            if ($scope.uploader.fastVideoTimer) {
                // 避免存在失败的情况还在轮训
                $timeout.cancel($scope.uploader.fastVideoTimer);
            }
            if ($scope.audio.audieoTimer) {
                $timeout.cancel($scope.audio.audieoTimer);
            }
            $scope.list.VIDEOREL = [];
            $scope.status.uploadOrChage = 'upload';
            $scope.audio.rotation = false;
            $scope.uploader.fastVideoInfo.status = '';
        };

        /**
         * [editVideo description]快编视频
         * @return {[type]} [description]
         */
        $scope.fastEditVideo = function () {
            $scope.loadingPromise = editCenUploadVideoForXjService.editVideo($scope.list).then(function (data) {
                uploadAudioTimeout();
                storgeVideoInfo(false, data); // 快编后等于又一次上传保存
                $scope.list.VIDEOREL[0].AUDIOVIDEOID = data.datas.videoid; // 回写ID
                window.open(data.datas.qediturl); // 打开快编页面
            });
        };

        /**
         * [cancelEditVideo description]取消快编
         * @return {[type]} [description]
         */
        $scope.cancelEditVideo = function () {
            $scope.loadingPromise = editCenUploadVideoForXjService.cancelEditVideo($scope.list).then(function (data) {
                $scope.list.VIDEOREL[0].AUDIOVIDEOID = data.videoId; // 回写ID
                $scope.list.VIDEOREL[0].URL = data.videoUrl;
                $scope.uploader.fastVideoInfo.status = editCenUploadVideoForXjService.videoDraftStatus[data.status];
                $timeout.cancel($scope.uploader.fastVideoTimer);
            });
        };

        /**
         * [storgeVideoInfo description]存储当前稿件视频信息
         * @param  {Boolean} isSave    [description]是否保存
         * @param  {[type]}  videoInfo [description]
         * @return {[type]}            [description]
         */
        function storgeVideoInfo(isSave, videoInfo) {
            if (!$state.params.appmetadataid) {
                // 只有编辑页才存储
                return;
            }
            var storage = localStorageService.get('videoUploadAppInfo') || {};
            if (isSave) {
                delete storage[$state.params.appmetadataid]; // 保存后删除记录
            } else {
                storage[$state.params.appmetadataid || 0] = [videoInfo.datas.videoid]; // 不保存的话存储状态
            }
            localStorageService.set('videoUploadAppInfo', storage); // 记录上传后的视频信息
        }

        /**
         * [uploadAsync description]上传后的异步操作
         * @param  {[obj]} videoInfo [description]上传的文件信息
         * @return {[type]}     [description]
         */
        function uploadAsync(videoInfo) {
            $scope.list.VIDEOREL = [];
            $scope.uploader.progress = 0;
            $timeout(function () {
                $scope.uploader.fastVideoInfo.status = '转码中';
                $scope.list.VIDEOREL.push({
                    AUDIOVIDEOID: videoInfo.videoid,
                    URL: videoInfo.path || videoInfo.resourceurl,
                    REMARKS: '',
                    PLATFORMFLAG: 'BDVideoObject',
                    ThumbImg: videoInfo.thumbimg,
                });
            });
            uploadAudioTimeout(); // 上传成功后就轮训
        }

        /**
         * [wordToAudioTimeout description] 文字转音频方法
         * @param   {[obj]}  params  [params description] 请求参数
         * @return  {[type]}         [return description]
         */
        function wordToAudioTimeout(params) {
            $scope.audio.audieoTimer = $timeout(function () {
                editCenUploadVideoForXjService.getAudioInfo(params).then(
                    function (data) {
                        if (data.datas.status !== 1) {
                            // 1表示转码完成
                            wordToAudioTimeout(params);
                        } else {
                            $scope.list.VIDEOREL = [
                                {
                                    AUDIOVIDEOID: data.datas.videoid,
                                    URL: data.datas.audiourl,
                                    REMARKS: '',
                                    PLATFORMFLAG: 'BDAudioObject',
                                    ThumbImg: '',
                                },
                            ];
                            $scope.audio.rotation = false;
                        }
                    },
                    function (error) {
                        modalDialog.alertType('转换失败', error.msg, 'warning', false);
                        $scope.audio.rotation = false;
                        $scope.deleteVideo();
                    }
                );
            }, $scope.audio.interval);
        }

        /**
         * [uploadAudioTimeout description]
         * @return  {[type]}  [return description]
         */
        function uploadAudioTimeout() {
            $scope.uploader.fastVideoTimer = $timeout(function () {
                getVideoInfo();
            }, editCenUploadVideoForXjService.videoPollInterval);
        }

        /**
         * [wordToAudio description]
         * @return  {[type]}  [return description]
         */
        $scope.wordToAudio = function () {
            var registerParams = {
                speaker: 'kangge',
                content: getContentWithoutImagenote(),
            }; // 注册任务参数
            if (!registerParams.content) {
                return;
            }
            $scope.status.uploadOrChage = 'change'; // 表示进入语音转换状态
            loginService
                .getCurrLoginUser()
                .then(function (user) {
                    registerParams.tenantId = user.TENANTID;
                    return globleParamsSet.getTokenService(user.TENANTID);
                })
                .then(function (tokenInfo) {
                    registerParams.userId = tokenInfo.token;
                    editCenUploadVideoForXjService.registerWordToAudio(registerParams).then(
                        function (data) {
                            startChange(registerParams, data);
                        },
                        function () {
                            modalDialog.alertType('转换失败', '请重新操作', 'warning', false);
                        }
                    );
                });
        };

        /**
         * [getContentWithoutImagenote description] 获得不带图说的正文字段
         * @return  {[str]}  [return description] 去除图说后的正文
         */
        function getContentWithoutImagenote() {
            var html = UE.getEditor('ueditor')
                .getContent()
                .replace(/<p (class|type)=\"imagenote\".+?<\/p>/g, '');
            var content = ueditorService.getTextContent(html, true);
            if (content.length < $scope.audio.lastWords) {
                modalDialog.alertType('操作失败', `请至少输入${$scope.audio.lastWords}个字`, 'warning', false);
                return;
            }
            return content;
        }

        /**
         * [startChange description]开始转换语音
         * @param   {[obj]}      params    [params description] 请求参数
         * @param   {[obj]}      data      [data description] 注册视频后的返回值
         * @return  {[undefined]}          [return description]
         */
        function startChange(params, data) {
            var getInfoParams = angular.copy(params);
            delete getInfoParams.content;
            getInfoParams.audioId = data.datas.audioid;
            $scope.audio.rotation = true;
            wordToAudioTimeout(getInfoParams);
        }
        // 上传音频&&文字转音频结束
        /**
         * [syncTitleToListTitle 将文章标题同步给列表标题]
         * @return  {[type]}  [return description]
         */
        $scope.syncTitleToListTitle = function () {
            syncTitleToListTitle();
        };

        /**
         * [syncTitleToListTitle 将文章标题同步给列表标题实现]
         * @return  {[type]}  [return description]
         */
        function syncTitleToListTitle() {
            if ($scope.status.hasTitleSynced) {
                return;
            } else {
                if ($scope.list.LISTTITLE !== '') {
                    return;
                } else {
                    $scope.list.LISTTITLE = $scope.list.TITLE;
                    $scope.status.hasTitleSynced = true;
                }
            }
        }

        /**
         * [changeMode description] 列表图模式切换，html调用
         * @param   {[type]}  listStyle  [listStype description]
         * @return  {[type]}             [return description]
         */
        $scope.changeMode = function (listStyle) {
            $scope.list.LISTSTYLE = listStyle.value;
            changeMode(listStyle.value);
        };

        /**
         * [changeMode description] js内部调用
         * @param   {[type]}  value  [listStype description]
         * @return  {[type]}  [return description]
         */
        function changeMode(value) {
            if ($scope.status.pictureSize) {
                switch (value) {
                    case '0':
                        $scope.data.imgSize = $scope.status.pictureSize.TOPSIZE;
                        break;
                    case '3':
                        $scope.data.imgSize = $scope.status.pictureSize.TOPBIGSIZE;
                        break;
                }
            }
        }

        /**
         * [关闭窗口]
         */
        $scope.closeWindow = function(){
            editingCenterService.closeWindow('app', $scope);
        };

        /**
         * [保存内容并关闭窗口]
         */
        $scope.saveAndClose = function() {
            $scope.save(false).then(function(){
                window.close();
            });
        };
    },
]);
